import { render, staticRenderFns } from "./AdminEditVehicleSidebar.vue?vue&type=template&id=23099d23&scoped=true&"
import script from "./AdminEditVehicleSidebar.vue?vue&type=script&lang=ts&"
export * from "./AdminEditVehicleSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23099d23",
  null
  
)

export default component.exports